var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { FormattedMessage } from "@irati/utils/lang";
import { H3, H4 } from "@irati/ui/src/Typography";
import { Hr } from "@irati/ui/src/Layout";
import Button from "./styled/Button";
import { Row, RowMiddle, RowEnd } from "../../Row/index";
import Products from "../../Products";
var Team = /** @class */ (function (_super) {
    __extends(Team, _super);
    function Team() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Team.prototype.render = function () {
        var _a = this.props, setCurrentTeam = _a.setCurrentTeam, public_name = _a.public_name, permissionsForTeam = _a.permissionsForTeam, permissionsForTenant = _a.permissionsForTenant, hideHr = _a.hideHr, buttonText = _a.buttonText, largeHeading = _a.largeHeading;
        var teamButtonText = buttonText || "admin.components.team.button.text";
        var Heading = largeHeading ? H3 : H4;
        return (React.createElement(React.Fragment, null,
            !hideHr && React.createElement(Hr, null),
            React.createElement(Row, null,
                React.createElement(RowMiddle, null,
                    React.createElement(Heading, null, public_name)),
                permissionsForTenant && React.createElement(Products, { permissionsForTeam: permissionsForTeam, permissionsForTenant: permissionsForTenant }),
                React.createElement(RowEnd, null, setCurrentTeam && (React.createElement(Button, { onClick: setCurrentTeam, small: true, id: "button_viewTeam_" + public_name },
                    React.createElement(FormattedMessage, { id: teamButtonText })))))));
    };
    return Team;
}(PureComponent));
export default Team;
